<template>
  <div v-if="areDownloadsVisible">
    <basket-icon-link
      v-for="(download, index) in downloads"
      :key="index"
      class="proposal-downloads__link"
      data-test-proposal-download-item
      :text="download.text"
      :link="download.url"
      icon-class="icon-download"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { BasketProposalDownload } from '@/store/modules/interfaces/ProposalBasketStoreState';
import BasketIconLink from './BasketIconLink.vue';

export default defineComponent({
  name: 'ProposalDownloads',
  components: {
    BasketIconLink
  },
  props: {
    downloads: {
      type: Array as PropType<BasketProposalDownload[]>,
      default() {
        return [] as BasketProposalDownload[];
      }
    }
  },
  computed: {
    areDownloadsVisible(): boolean {
      return this.downloads && this.downloads.length > 0;
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.proposal-downloads {
  &__link {
    margin-top: rem-calc(8);
  }
}
</style>
